export class Employee{
  constructor(
    public ID:number,
    private name:string,
    private father_last_name:string,
    private mother_last_name:string,
    private address: string,
    private phone:string,
    private User_ID:number
  )
  {

  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/models/employee.model.ts